<template>
    <div class="main detail">

        <div v-if="message" class="empty-list">
            {{ message }}
            <div v-if="loadingItem" class="loading"><i class="fas fa-spinner fa-spin"></i></div>
        </div>

        <div v-if="item" class="report-heading" style="position: relative;">
            <h1>{{ item_title }}</h1>
            <div class="controls"><div :class="['button action', section]" @click="$router.go(-1)"><i class="fas fa-chevron-left"></i></div></div>
            <h3 v-if="section == 'manufacturers'" style="position: absolute; left: 0; bottom: -1em;">Real time reporting data from over {{ item.reporting_dealers }} dealers</h3>
        </div>

        <div v-if="item" class="item-detail">
            <div class="item-details">
                <div class="item-image">
                    <img :src="item.image_src">
                </div>
                <div class="specifications">
                    <label>UPC</label><span>{{ item.upc }}</span>
                    <label>Manufacturer</label><span>{{ item.manufacturer }}</span>
                    <label>Model</label><span>{{ item.model }}</span>
                    <label>SKU</label><span>{{ item.sku }}</span>
                    <label>Caliber</label><span>{{ item.caliber }}</span>
                    <label>MAP</label><span>{{ item.map }}</span>
                    <label>MSRP</label><span>{{ item.msrp }}</span>
                </div>
                <div v-if="section == 'manufacturers'" class="specifications-manufacturers">
                    <div class="distributor-rows">
                        <label class="meta">Distributor</label>
                        <label class="meta">On Hand</label>
                        <template v-for="distributor in item_distributors">
                            <label class="meta">{{ distributor.description }}</label>
                            <div class="meta">{{ distributor.on_hand }}</div>
                        </template>
                        <label class="meta">Low Distributor Cost</label><div class="meta">{{ Number(item.distributor_min_cost).toFixed(2) }}</div>
                        <label class="meta">High Distributor Cost</label><div class="meta">{{ Number(item.distributor_max_cost).toFixed(2) }}</div>
                        <label class="meta">Average Dealer Cost</label><div class="meta">{{ Number(item.average_cost).toFixed(2) }}</div>
                        <label class="meta">Average Dealer Retail</label><div class="meta">{{ Number(item.average_price).toFixed(2) }}</div>
                    </div>
                    <div class="supplier-rows">
                        <label class="meta">Suppliers YTD</label>
                        <label class="meta">Received</label>
                        <template v-for="supplier in item_suppliers">
                            <label class="meta">{{ supplier.description }}</label>
                            <div class="meta">{{ supplier.received }}</div>
                        </template>
                    </div>
                </div>
                <div v-else class="specifications-wide">
                    <label></label>
                    <label class="meta">Cost</label>
                    <label class="meta">On Hand</label>
                    <label class="meta">Days<br>Out of Stock</label>
                    <label class="meta">% Days<br>Out of Stock</label>
                    <template v-for="distributor in item_distributors">
                        <label :key="'label1_' + distributor.location_id">{{ distributor.description }}</label>
                        <span :key="'span1_' + distributor.location_id">{{ distributor.cost }}</span>
                        <span :key="'label2_' + distributor.location_id" class="meta">{{ distributor.on_hand }}</span>
                        <span :key="'label3_' + distributor.location_id" class="meta">{{ distributor.days_out_of_stock }}</span>
                        <span :key="'label4_' + distributor.location_id" class="meta">{{ distributor.percent_out_of_stock }}%</span>
                    </template>
                    <label>Average Dealer Cost</label><span>{{ Number(item.average_cost).toFixed(2) }}</span><span></span><span></span><span></span>
                    <label>Average Dealer Retail</label><span>{{ Number(item.average_price).toFixed(2) }}</span><span></span><span></span><span></span>
                </div>
            </div>

            <div style="margin: 0 0 3em 0;">
                <div class="data-heading">
                    <h2 :class="['heading', currentSection == 'inventory' ? 'live' : '']" @click="changeSection('inventory')">Inventory</h2>
                    <h2 :class="['heading', currentSection == 'suppliers' ? 'live' : '']" @click="changeSection('suppliers')">Suppliers</h2>
                    <h2 :class="['heading', currentSection == 'sales' ? 'live' : '']" @click="changeSection('sales')">Sales</h2>
                    <h2 :class="['heading', currentSection == 'warehouse' ? 'live' : '']" @click="changeSection('warehouse')">Warehouse</h2>
                    <h2 :class="['heading', currentSection == 'distributors' ? 'live' : '']" @click="changeSection('distributors')">Distributors</h2>
                </div>

                <div v-if="messageData" class="empty-list chart-loading">
                    {{ messageData }}
                    <div v-if="loadingData" class="loading"><i class="fas fa-spinner fa-spin"></i></div>
                </div>

                <div v-else :class="[currentSection, 'chart-content', 'ct-chart']">
                    <chartist
                        ratio=""
                        :type="chartType"
                        :data="chartData"
                        :options="chartOptions">
                    </chartist>
                </div>

                <div v-if="currentSection == 'inventory'" class="legend">
                    <div class="color series-a-inventory"></div><div class="label">On Hand</div>
                    <div class="color series-b-inventory"></div><div class="label">Sales</div>
                    <div v-if="chartData.labels">(Last {{ chartData.labels.length - 1 }} Days)</div>
                </div>

                <div v-if="currentSection == 'suppliers'" class="legend legend-wide">
                    <div>Received YTD</div>
                </div>

                <div v-if="currentSection == 'sales'" class="legend">
                    <div class="color series-a-sales"></div><div class="label">POS</div>
                    <div class="color sferies-b-sales"></div><div class="label">Online</div>
                    <template v-if="item.serializable">
                        <div class="color series-c-sales"></div><div class="label">Disposed</div>
                    </template>
                    <div v-if="chartData.labels">(Last {{ chartData.labels.length - 1 }} Days)</div>
                </div>

                <div v-if="currentSection == 'warehouse'" class="legend">
                    <div class="color series-a-warehouse"></div><div class="label">POS</div>
                    <div class="color series-b-warehouse"></div><div class="label">Online</div>
                    <div class="color series-c-warehouse"></div><div class="label">Assembly</div>
                </div>

                <div v-if="currentSection == 'distributors'" class="legend">
                    <div class="color series-a-distributors"></div><div class="label">{{ legendLabels[0] }}</div>
                    <div class="color series-b-distributors"></div><div class="label">{{ legendLabels[1] }}</div>
                    <div class="color series-c-distributors" v-if="legendLabels[2]"></div><div class="label" v-if="legendLabels[2]">{{ legendLabels[2] }}</div>
                    <div class="color series-d-distributors" v-if="legendLabels[3]"></div><div class="label" v-if="legendLabels[3]">{{ legendLabels[3] }}</div>
                    <div class="color series-e-distributors" v-if="legendLabels[4]"></div><div class="label" v-if="legendLabels[4]">{{ legendLabels[4] }}</div>
                </div>

            </div>

            <div class="two-one-columns">
                <div class="bar-graph" style="width: 100%; height: 2em; background-color: #ccc;">
                    <div :style="'float: left; position: relative; height: 2em; background-color: rgba(3, 142, 24, 1); width: ' + chartPercentagesDealers.in_stock + '%;'">
                        <div style="position: absolute; left: 0; top: -1.4em; border-left: 1px solid #999; width: 20em; padding: 0 0 0 0.5em;">In Stock {{ chartPercentagesDealers.in_stock }}%</div>
                    </div>
                    <div :style="'float: left; position: relative; height: 2em; background-color: rgba(3, 142, 24, 0.7); width: ' + chartPercentagesDealers.out_of_stock + '%;'">
                        <div style="position: absolute; left: 0; bottom: -1.4em; border-left: 1px solid #999; width: 20em; padding: 0 0 0 0.5em;">Out of Stock {{ chartPercentagesDealers.out_of_stock }}%</div>
                    </div>
                    <div :style="'float: left; position: relative; height: 2em; background-color: rgba(3, 142, 24, 0.2); width: ' + chartPercentagesDealers.non_stocking + '%;'">
                        <div style="position: absolute; right: 0; top: -1.4em; border-right: 1px solid #999; text-align: right; width: 20em; padding: 0 0.5em 0 0;">Not Stocked {{ chartPercentagesDealers.non_stocking }}%</div>
                    </div>
                </div>

                <div class="bar-graph" style="width: 100%; height: 2em; background-color: #ccc;">
                    <div :style="'float: left; position: relative; height: 2em; background-color: rgba(3, 142, 24, 1); width: ' + chartDataSales.pos_sales + '%;'">
                        <div style="position: absolute; left: 0; top: -1.4em; border-left: 1px solid #ccc; width: 20em; padding: 0 0 0 0.5em;">Sold In Store {{ chartDataSales.pos_sales }}%</div>
                    </div>
                    <div :style="'float: left; position: relative; height: 2em; background-color: rgba(3, 142, 24, 0.5); width: ' + chartDataSales.web_sales + '%;'">
                        <div style="position: absolute; right: 0; bottom: -1.4em; border-right: 1px solid #ccc; text-align: right; width: 20em; padding: 0 0.5em 0 0;">Sold Online {{ chartDataSales.web_sales }}%</div>
                    </div>
                </div>

            </div>

            <div v-if="showDealerDetail">

                <div v-if="messageDealerData" class="empty-list">
                    {{ messageDealerData }}
                    <div v-if="loadingDealerData" class="loading"><i class="fas fa-spinner fa-spin"></i></div>
                </div>

                <div v-else>
                    <div class="report-row dealer-detail-heading">
                        <h2>{{ dealerDetail.company_name }}</h2>
                        <div class="controls">
                            <div :class="['button', section]" @click="showDealerDetail = false"><i class="fas fa-chevron-left"></i></div>
                        </div>
                    </div>
                    <div class="two-columns">
                        <div style="border-right: 1px solid #ccc; padding-right: 1em;">
                            <h3>Inventory & Sales <span class="caption">(last 30 days)</span></h3>
                            <div class="dealer-list">
                                <div class="report-row inventory-history">
                                    <div>Onhand Start</div>
                                    <div class="numbers full">{{ dealerData.inventoryHistory.onhand_start }}</div>
                                </div>
                                <div class="report-row inventory-history">
                                    <div>Received</div>
                                    <div class="numbers full">{{ dealerData.inventoryHistory.received }}</div>
                                </div>
                                <div class="report-row inventory-history">
                                    <div>Sold POS</div>
                                    <div class="numbers full">{{ dealerData.inventoryHistory.units_sold_pos }}</div>
                                    <div class="numbers full"><label>Cost</label>{{ dealerData.inventoryHistory.cost_sold_pos || 0}}</div>
                                    <div class="numbers full"><label>Price</label>{{ dealerData.inventoryHistory.price_sold_pos || 0 }}</div>
                                </div>
                                <div class="report-row inventory-history">
                                    <div>Sold Online</div>
                                    <div class="numbers full">{{ dealerData.inventoryHistory.units_sold_online }}</div>
                                    <div class="numbers full"><label>Cost</label>{{ dealerData.inventoryHistory.cost_sold_online || 0 }}</div>
                                    <div class="numbers full"><label>Price</label>{{ dealerData.inventoryHistory.price_sold_online || 0 }}</div>
                                </div>
                                <div class="report-row inventory-history">
                                    <div>Sold Logbooks</div>
                                    <div class="numbers full">{{ dealerData.inventoryHistory.units_sold_logbooks }}</div>
                                    <div class="numbers full"><label>Cost</label>{{ dealerData.inventoryHistory.cost_sold_logbooks || 0 }}</div>
                                    <div class="numbers full"><label>Price</label>{{ dealerData.inventoryHistory.price_sold_logbooks || 0 }}</div>
                                </div>
                                <div class="report-row inventory-history">
                                    <div>Days Out Of Stock</div>
                                    <div class="numbers full">{{ dealerData.inventoryHistory.days_out_of_stock }}</div>
                                </div>
                                <div class="report-row inventory-history">
                                    <div>Onhand End</div>
                                    <div class="numbers full">{{ dealerData.inventoryHistory.onhand_end }}</div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <h3>Suppliers <span class="caption">(last 90 days)</span></h3>
                            <div class="dealer-list">
                                <div class="report-row heading supplier-history">
                                    <label style="text-align: left;">Supplier</label>
                                    <label class="numbers full">Received</label>
                                    <label class="numbers full">Cost</label>
                                </div>
                                <div v-for="(history, index) in dealerData.supplierHistory" :key="index" class="report-row supplier-history">
                                    <div>{{ history.description }}</div>
                                    <div class="numbers full">{{ history.received }}</div>
                                    <div class="numbers full">{{ history.cost }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="daily-history-filters">
                        <h3>Daily History</h3>
                        <div class="input-with-control date-control">
                            <label>Start</label>
                            <label>End</label>
                            <label></label>
                            <input type="date" :max="filters.end_date" v-model="filters.start_date" required="required">
                            <input type="date" :min="filters.start_date" v-model="filters.end_date" required="required">
                            <div :class="['button', 'input-go', section ]" @click="setFilter('dates')"><i class="fas fa-calendar-check"></i></div>
                        </div>
                    </div>

                    <div class="dealer-list">
                        <div class="report-row heading dealer-history">
                            <label style="text-align: left;">Date</label>
                            <label class="numbers full">On Hand</label>
                            <label class="numbers full">Ordered</label>
                            <label class="numbers full">Received</label>
                            <label class="numbers full">Sold POS</label>
                            <label class="numbers full">Sold Online</label>
                            <label class="numbers full">Disposed</label>
                            <label class="numbers full">Cost</label>
                            <label class="numbers full">Price</label>
                            <label class="numbers full">Online Price</label>
                            <label></label>
                        </div>
                        <div v-for="(history, index) in dealerHistory" :key="index" class="report-row dealer-history">
                            <div>{{ history.log_date }}</div>
                            <div class="numbers full">{{ history.quantity }}</div>
                            <div class="numbers full">{{ history.ordered }}</div>
                            <div class="numbers full">{{ history.received }}</div>
                            <div class="numbers full">{{ history.sold_pos }}</div>
                            <div class="numbers full">{{ history.sold_online }}</div>
                            <div class="numbers full">{{ history.disposed }}</div>
                            <div class="numbers full">{{ history.cost }}</div>
                            <div class="numbers full">{{ history.price }}</div>
                            <div style="text-align: right;">
                                <div :class="['button', section]" @click="editProductLocation(history)"><i class="fas fa-edit"></i></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div v-else style="position: relative; padding: 2em 0 0 0;">

                <!-- <div style="position: absolute; top: -2.5em; right: 40%;">
                    <div :class="[currentSection, 'chart-content', 'ct-chart']">
                        <chartist
                            ratio=""
                            type="Pie"
                            :data="chartDataDealers"
                            :options="chartOptionsDealers">
                        </chartist>
                    </div>
                </div> -->

                <h2 class="heading">
                    Inventory Dealers ({{ dealersPaging.total_items }})
                    <button v-if="isAdmin" :class="['button', selectedDealers.length > 0 ? section : 'disabled']" @click="emailSelectedDealers()">Email Selected Dealers</button>
                </h2>
                <div v-if="messageDealers" class="empty-list">
                    {{ messageDealers }}
                </div>

                <div :class="['dealer-list', { loading: loadingDealers } ]">

                    <div :class="['report-row', 'heading', section]">
                        <div>
                            <input v-if="isAdmin" type="checkbox" v-model="selectingAllStockingDealers" @click="selectAllDealers('stocking_dealers')" style="margin: 0 1em 0 0;"/>
                            <input type="text" placeholder="Filter inventory dealer list..." v-model="filterList" style="width: 18em;">
                        </div>
                        <label :class="['numbers full sortable', { sortcurrent: filters.sort_column == 'cost_each' } ]" @click="setDealerSort('cost_each')">Cost Each <i v-if="filters.sort_column == 'cost_each'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                        <label :class="['numbers full sortable', { sortcurrent: filters.sort_column == 'price_each' } ]" @click="setDealerSort('price_each')">Price Each <i v-if="filters.sort_column == 'price_each'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                        <label :class="['numbers full sortable', { sortcurrent: filters.sort_column == 'on_hand' } ]" @click="setDealerSort('on_hand')">On Hand <i v-if="filters.sort_column == 'on_hand'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                        <label :class="['numbers full sortable', { sortcurrent: filters.sort_column == 'cost_on_hand' } ]" @click="setDealerSort('cost_on_hand')">Cost<br>On Hand <i v-if="filters.sort_column == 'cost_on_hand'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                        <label :class="['numbers full sortable', { sortcurrent: filters.sort_column == 'price_on_hand' } ]" @click="setDealerSort('price_on_hand')">Price<br>On Hand <i v-if="filters.sort_column == 'price_on_hand'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                        <label :class="['numbers full sortable', { sortcurrent: filters.sort_column == 'sold_pos' } ]" @click="setDealerSort('sold_pos')">Sold<br>POS <i v-if="filters.sort_column == 'sold_pos'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                        <label :class="['numbers full sortable', { sortcurrent: filters.sort_column == 'sold_online' } ]" @click="setDealerSort('sold_online')">Sold<br>Online <i v-if="filters.sort_column == 'sold_online'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                        <label :class="['numbers full sortable', { sortcurrent: filters.sort_column == 'disposed_logbooks' } ]" @click="setDealerSort('disposed_logbooks')">Disposed <i v-if="filters.sort_column == 'disposed_logbooks'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                        <label :class="['numbers full sortable', { sortcurrent: filters.sort_column == 'sold_cost' } ]" @click="setDealerSort('sold_cost')">Cost Sold<br>Or Disposed <i v-if="filters.sort_column == 'sold_cost'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                        <label :class="['numbers full sortable', { sortcurrent: filters.sort_column == 'sold_price' } ]" @click="setDealerSort('sold_price')">Price Sold<br>Or Disposed <i v-if="filters.sort_column == 'sold_price'" :class="['fas', filters.sort_descending ? 'fa-caret-down' : 'fa-caret-up']"></i></label>
                        <label></label>
                    </div>
                    <template v-for="(dealer, index) in dealers">
                        <div :class="['report-row', section]" :key="index" v-if="filterList == '' || dealer.company_name.toLowerCase().indexOf(filterList.toLowerCase()) > -1">
                            <div class="dealer-name">
                                <input v-if="isAdmin" type="checkbox" @click="updateSelectedDealers(dealer)" :checked="selectedDealers.indexOf(dealer.client_id) > -1" :disabled="dealer.client_type_code == 'FFL_OFFICE'"/>
                                <label v-else></label>
                                <i v-if="dealer.client_type_code == 'FFL_OFFICE'" class="logbooks-only fas fa-book-open" title="Firearms Only"></i>
                                <i v-else class="full-cds fas fa-store-alt" title="Full Use Dealer"></i>
                                <span>{{ dealer.company_name }}<br>
                                <label class="meta">{{ dealer.city }}, {{ dealer.state }}</label></span>
                            </div>
                            <div class="numbers full">{{ dealer.cost_each || '' }}</div>
                            <div class="numbers full">{{ dealer.price_each || '' }}</div>
                            <div class="numbers full">{{ dealer.on_hand || 0 }}</div>
                            <div class="numbers full">{{ dealer.cost_on_hand || 0 }}</div>
                            <div class="numbers full">{{ dealer.price_on_hand || 0 }}</div>
                            <div class="numbers full">{{ dealer.sold_pos || 0 }}</div>
                            <div class="numbers full">{{ dealer.sold_online || 0 }}</div>
                            <div class="numbers full">{{ dealer.disposed_logbooks || 0 }}</div>
                            <div class="numbers full">{{ dealer.sold_cost || 0 }}</div>
                            <div class="numbers full">{{ dealer.sold_price || 0 }}</div>
                            <div style="text-align: right;">
                                <div v-if="dealer.location_id" :class="['button', section]" @click="getDealer(dealer)"><i class="fas fa-list"></i></div>
                            </div>
                        </div>
                    </template>

                    <div :class="['report-row', 'heading', section]">
                        <div>
                            <div :class="['load-more-link', dealersPaging.total_items > dealers.length ? section : 'disabled']" @click="loadMore('inventory-dealers')">
                                Load more... <i v-if="loadingDealers" class="fas fa-spinner fa-spin"></i>
                            </div>
                            <div :class="['load-more-link', dealers.length > dealersPaging.items_per_page ? section : 'disabled']" @click="loadLess('inventory-dealers')">Load less...</div>
                        </div>
                        <div class="numbers full"></div>
                        <div class="numbers full"></div>
                        <div class="numbers full"><b>{{ dealerTotals.on_hand || 0 }}</b></div>
                        <div class="numbers full"><b>{{ formatCurrency(dealerTotals.cost_on_hand) || 0 }}</b></div>
                        <div class="numbers full"><b>{{ formatCurrency(dealerTotals.price_on_hand) || 0 }}</b></div>
                        <div class="numbers full"><b>{{ dealerTotals.sold_pos || 0 }}</b></div>
                        <div class="numbers full"><b>{{ dealerTotals.sold_online || 0 }}</b></div>
                        <div class="numbers full"><b>{{ dealerTotals.disposed_logbooks || 0 }}</b></div>
                        <div class="numbers full"><b>{{ formatCurrency(dealerTotals.sold_cost) || 0 }}</b></div>
                        <div class="numbers full"><b>{{ formatCurrency(dealerTotals.sold_price) || 0 }}</b></div>
                        <div style="text-align: right;"></div>
                    </div>

                </div>

                <h2 class="heading">Non-Inventory Dealers ({{ nonStockingDealersPaging.total_items }})</h2>
                <div v-if="messageDealers" class="empty-list">
                    {{ messageDealers }}
                </div>
                <div v-if="nonStockingDealers.length > 0" class="dealer-list dealer-list-non-stocking">
                    <div :class="['report-row', 'heading', section]">
                        <div>
                            <input v-if="isAdmin" type="checkbox" v-model="selectingAllNonStockingDealers" @click="selectAllDealers('non_stocking_dealers')" style="margin: 0 1em 0 0;"/>
                            <input type="text" placeholder="Filter non-invenotry dealer list..." v-model="nonStockingFilterList" style="width: 18em;">
                        </div>
                    </div>
                    <template v-for="(dealer, index) in nonStockingDealers">
                        <div :class="['report-row', section]" :key="index" v-if="nonStockingFilterList == '' || dealer.company_name.toLowerCase().indexOf(nonStockingFilterList.toLowerCase()) > -1">
                            <div class="dealer-name">
                                <!-- <input v-if="isAdmin" type="checkbox" @click="updateSelectedDealers(dealer)" :checked="selectedDealers.indexOf(dealer.client_id) > -1" :disabled="dealer.client_type_code == 'FFL_OFFICE'" /> -->
                                <input v-if="isAdmin" type="checkbox" @click="updateSelectedDealers(dealer)" :checked="selectedDealers.indexOf(dealer.client_id) > -1" :disabled="dealer.client_type_code == 'FFL_OFFICE'"/>
                                <label v-else></label>
                                <i v-if="dealer.client_type_code == 'FFL_OFFICE'" class="logbooks-only fas fa-book-open" title="Logbooks only dealer"></i>
                                <i v-else class="full-cds fas fa-store-alt" title="Full CDS dealer"></i>
                                <span>{{ section == 'manufacturers' ? (dealer.client_type_code == 'FFL_OFFICE' ? 'Logbooks Only' : 'Full Use') : dealer.company_name }} <label class="meta">{{ dealer.city }}, {{ dealer.state }}</label></span>
                            </div>
                        </div>
                    </template>

                    <div :class="['load-more-link', nonStockingDealersPaging.total_items > nonStockingDealers.length ? section : 'disabled']" @click="loadMore('non-inventory-dealers')">
                        Load more... <i v-if="loadingNonStockingDealers" class="fas fa-spinner fa-spin"></i>
                    </div>
                    <div :class="['load-more-link', nonStockingDealers.length > nonStockingDealersPaging.items_per_page ? section : 'disabled']" @click="loadLess('non-inventory-dealers')">Load less...</div>

                </div>
            </div>

        </div>

        <div v-if="showModal" class="modal">
            <div class="inner">
                <h2>Edit Daily History</h2>
                <div class="content">
                    <div class="two-columns">
                        <div>
                            <label>On Hand</label>
                            <input type="text" v-model="editingLocation.quantity">
                            <label>Received</label>
                            <input type="text" v-model="editingLocation.received">
                            <label>Cost</label>
                            <input type="text" v-model="editingLocation.cost">
                            <label>Price</label>
                            <input type="text" v-model="editingLocation.price">
                        </div>
                        <div style="font-size: 0.9em; margin: 1.75em 0 0 0; line-height: 2em;">
                            <p>Editing daily history for <b>{{ editingLocation.log_date }}</b></p>
                            <p>Which dates should changes apply to?</p>
                            <div style="margin: 0 0 0 1em;">
                                <input type="radio" value="all" v-model="editingLocationScope"> This and all dates (past and future)<br>
                                <input type="radio" value="past" v-model="editingLocationScope"> This and past dates only<br>
                                <input type="radio" value="only" v-model="editingLocationScope"> This date only<br>
                                <input type="radio" value="delete" v-model="editingLocationScope"> Delete this product location
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-controls">
                    <div class="button cancel" @click="showModal = false">Cancel</div>
                    <div :class="['button', section]" @click="saveProductLocation()">Save</div>
                    <div v-if="editProductLocationMessage" class="message">{{ editProductLocationMessage }}</div>
                </div>
            </div>
        </div>

        <div v-if="showModalEmailDealers" class="modal email-dealers-modal">
            <div class="inner">
                <h2>Email Selected Dealers</h2>
                <div class="content">
                    <h3 class="item-title">{{ this.item_title }}</h3>
                    <label class="email-label">Send email to these {{ selectedDealerData().length }} dealers...</label>
                    <div v-for="(dealer, index) in selectedDealerData()" class="dealer-name-modal">
                        <i v-if="dealer.client_type_code == 'FFL_OFFICE'" class="logbooks-only fas fa-book-open" title="Logbooks only dealer"></i>
                        <i v-else class="full-cds fas fa-store-alt" title="Full CDS dealer"></i>
                        <span>{{ dealer.company_name }} <label class="meta">{{ dealer.hasOwnProperty('on_hand') ? 'Inventory' : 'Non-inventory' }}, {{ dealer.email_address }}</label></span>
                    </div>
                    <label class="email-label">Email subject...</label>
                    <input type="text" v-model="dealerEmail.subject"/>
                    <label class="email-label">Alert type...</label>
                    <select v-model="dealerEmail.alert_type">
                        <option value="">Select...</option>
                        <option value="high-turnover">High Turnover / Sales Volume</option>
                        <option value="high-margin">Above Average Margin</option>
                        <option value="low-inventory">Possible Low Inventory</option>
                    </select>
                    <label class="email-label">Email content...</label>
                    <TiptapEditor :modelValue="dealerEmail.content" @update="updateEmailContent" />
                    <div class="two-columns">
                        <div>
                            <label class="email-label">Clean product title...</label>
                            <input type="text" v-model="dealerEmail.product_title"/>
                        </div>
                        <div>
                            <label class="email-label">Distributor order links to...</label>
                            <input type="radio" value="RSR" v-model="dealerEmail.distributor"> RSR Group<br>
                            <input type="radio" value="SS" v-model="dealerEmail.distributor"> Sports South<br>
                        </div>
                        <div>
                            <label class="email-label">Order Quantity...</label>
                            <input type="number" v-model="dealerEmail.order_quantity"/>
                        </div>
                        <div>
                            <label class="email-label">Order before date...</label>
                            <input type="date" v-model="dealerEmail.order_by_date"/>
                        </div>
                    </div>
                </div>
                <div class="modal-controls">
                    <div class="button cancel" @click="showModalEmailDealers = false">Cancel</div>
                    <div :class="['button', validateDealerEmail() ? section : 'disabled' ]" @click="previewEmail()">Preview This Email</div>
                </div>
            </div>
        </div>

        <div v-if="showEmailPreview" class="email-preview">
            <div class="email-preview-inner">
                <div class="email-preview-content">
                    <div class="email-preview-meta">
                        <label>From</label>
                        <div>navigator@cds.email</div>
                        <label>Subject</label>
                        <div>{{ dealerEmail.subject }}</div>
                        <label>To</label>
                        <div><span v-for="(dealer, index) in selectedDealerData()">{{ dealer.email_address }}<span v-if="index < selectedDealerData().length - 1">, </span></span></div>
                    </div>
                    <div v-if="emailErrorContent" class="empty-list">{{ emailErrorContent }}</div>
                    <div v-else-if="emailPreviewContent" v-html="emailPreviewContent" />
                    <div v-else class="email-preview-loading"><i class="fas fa-spinner fa-spin"></i></div>
                </div>
                <div class="email-preview-controls two-columns">
                    <div class="button cancel" @click="showEmailPreview = false">Cancel</div>
                    <div :class="['button', section, { disabled: sendingDealerEmail || emailInvalid || dealerEmailMessage }]" @click="sendEmail()">{{ dealerEmailMessage || 'Send This Email' }}</div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import TiptapEditor from '@/components/TiptapEditor.vue'
export default {
    name: 'item',
    props: ['product_id','section'],
    components: {
        TiptapEditor
    },
    data() {
        return {
            isAdmin: false,
            loadingItem: true,
            message: 'Loading',
            currentSection: '',
            totals: {},
            item: [],
            item_title: 'Item',
            item_distributors: [],
            item_suppliers: [],
            chartData: {},
            chartOptions: {},
            chartType: 'Line',
            legendLabels: [],
            messageData: 'Loading',
            loadingData: true,
            messageDealers: '',
            loadingDealers: true,
            dealers: [],
            dealersPaging: {},
            dealerTotals: {},
            messageTotals: '',
            filterList: '',
            graph_data: '',
            dealerDetail: {},
            showDealerDetail: false,
            messageDealerData: '',
            loadingDealerData: false,
            dealerData: {
                inventoryHistory: [],
                supplierHistory: [],
                currentInventory: {}
            },
            messageDealerHistory: '',
            loadingDealerHistory: false,
            dealerHistory: [],
            acquireNonStockingDealerList: false,
            loadingNonStockingDealers: false,
            nonStockingDealers: [],
            nonStockingDealersPaging: {},
            nonStockingFilterList: '',
            filters: {
                product_id: this.product_id,
                section: this.section,
                sort_column: 'on_hand',
                sort_descending: true,
                start_date: this.getYearStartDate(),
                end_date: this.getYesterdaysDate(),
                page: 1
            },
            showModal: false,
            editProductLocationMessage: '',
            editingLocation: {},
            editingLocationScope: 'all',
            savingProductLocation: false,
            selectedDealers: [],
            selectingAllStockingDealers: false,
            selectingAllNonStockingDealers: false,
            showModalEmailDealers: false,
            editor: null,
            editorContent: '',
            dealerEmail: {
                subject: '',
                alert_type: '',
                content: '',
                product_title: '',
                distributor: '',
                order_quantity: 1,
                order_by_date: ''
            },
            showEmailPreview: false,
            sendingDealerEmail: false,
            emailInvalid: false,
            emailErrorContent: '',
            dealerEmailMessage: '',
            legacyAPI: '',
            emailPreviewContent: '',
            loadingChartDealers: false,
            chartDataDealers: {},
            chartOptionsDealers: {
                height: 110,
                chartPadding: 10,
                labelOffset: 33,
                labelDirection: 'explode',
                classNames: {
                    label: 'bigger-ct-label'
                }
            },
            chartPercentagesDealers: {},
            chartDataSales: {}
        }
    },
    created() {
        this.currentSection = this.section
        this.fetchData()
    },
    methods: {
		fetchData() {
            this.loadingItem = true
            this.apiCall({ destination: 'get_item', data: this.filters }).then(obj => {
                this.loadingItem = false
                if (obj.status == 'success') {
                    this.item = obj.item
                    this.item_title = this.item.clean_description
                    this.item_distributors = obj.distributors
                    this.item_suppliers = obj.suppliers
                    this.message = ''
                    this.fetchSectionData()
                    this.fetchTotals()
                    this.fetchChartData()
                    this.acquireNonStockingDealerList = true
                    this.fetchDealerList()
                } else {
                    this.message = obj.message
                }
            })
        },
        fetchTotals() {
            this.apiCall({ destination: 'get_dealer_product_totals', data: this.filters }).then(obj => {
                if (obj.status == 'success') {
                    this.dealerTotals = obj.dealer_totals
                    this.messageTotals = ''
                } else {
                    this.messageTotals = obj.message
                }
            })
        },
        fetchChartData() {
            if (this.loadingChartDealers) { return }
            this.loadingChartDealers = true
            this.chartDataDealers = {}
            this.apiCall({ destination: 'get_item_chart_data', data: this.filters }).then(obj => {
                this.loadingChartDealers = false
                if (obj.status == 'success') {
                    //this.chartDataDealers = obj.chart_data
                    this.chartPercentagesDealers = obj.chart_data_percentages
                    this.chartDataSales = obj.chart_data_sales
                }
            })
        },
        fetchDealerList(resetList) {
            if (this.loadingDelers) { return }
            this.loadingDealers = true
            if (this.dealers.length == 0) {
                this.messageDealers = 'Loading'
            }
            this.apiCall({ destination: 'get_list_dealers', data: this.filters }).then(obj => {
                this.loadingDealers = false
                if (obj.status == 'success') {
                    if (resetList) {
                        this.dealers = []
                    }
                    obj.dealers.forEach(dealer => {
                        this.dealers.push(dealer)
                        if (this.selectingAllStockingDealers) {
                            this.selectedDealers.push(dealer.client_id)
                        }
                    })
                    this.dealersPaging = obj.paging
                    this.isAdmin = this.getUser.user_type_code.indexOf('ADMIN') > -1
                    if (this.acquireNonStockingDealerList) {
                        this.fetchNonStockingDealerList()
                    }
                    this.messageDealers = ''
                } else {
                    this.messageDealers = obj.message
                }
            })
        },
        fetchNonStockingDealerList() {
            if (this.loadingNonStockingDealers) { return }
            this.loadingNonStockingDealers = true
            this.acquireNonStockingDealerList = false
            this.apiCall({ destination: 'get_list_non_stocking_dealers', data: this.filters }).then(obj => {
                this.loadingNonStockingDealers = false
                obj.non_stocking_dealers.forEach(dealer => {
                    this.nonStockingDealers.push(dealer)
                    if (this.selectingAllNonStockingDealers) {
                        this.selectedDealers.push(dealer.client_id)
                    }
                })
                this.nonStockingDealersPaging = obj.paging
            })
        },
        loadMore(which) {
            if (which == 'non-inventory-dealers') {
                this.acquireNonStockingDealerList = false
                this.filters.page = this.nonStockingDealersPaging.current_page + 1
                this.fetchNonStockingDealerList()
            } else {
                this.filters.page = this.dealersPaging.current_page + 1
                this.fetchDealerList()
            }
        },
        loadLess(which) {
            if (which == 'inventory-dealers') {
                if (this.dealersPaging.current_page > 1) {
                    let startFrom = (this.dealersPaging.current_page - 1) * this.dealersPaging.items_per_page
                    let howMany = this.dealers.length - ((this.dealersPaging.current_page - 1) * this.dealersPaging.items_per_page)
                    this.dealers.splice(startFrom, howMany);
                    this.dealersPaging.current_page--
                }
            } else {
                if (this.nonStockingDealersPaging.current_page > 1) {
                    let startFrom = (this.nonStockingDealersPaging.current_page - 1) * this.nonStockingDealersPaging.items_per_page
                    let howMany = this.nonStockingDealers.length - ((this.nonStockingDealersPaging.current_page - 1) * this.nonStockingDealersPaging.items_per_page)
                    this.nonStockingDealers.splice(startFrom, howMany);
                    this.nonStockingDealersPaging.current_page--
                }
            }
        },
        fetchSectionData() {
            this.chartData = {}
            this.messageData = 'Loading'
            this.loadingData = true
            // if we're here from manufacturers report, translate initial section to sales
            if (this.currentSection == 'manufacturers') {
                this.currentSection = 'sales'
            }
            this.apiCall({ destination: 'get_item_data', data: { product_id: this.product_id, serializable: this.item.serializable, section: this.currentSection } }).then(obj => {
                this.loadingData = false
                if (obj.status == 'success') {
                    if (obj.chart_data.labels.length > 0) {
                        switch (this.currentSection) {
                            case 'inventory':
                                // get the digit length of the max quantity in series and adjust axisY offset accordingly
                                var digitsInventory = obj.chart_data.max_series.toString().length // 555555591
                                this.chartOptions = {
                                    fullWidth: true,
                                    height: '14em',
                                    axisX: {
                                        labelOffset: {
                                            x: -12,
                                            y: 0
                                        }
                                    },
                                    axisY: {
                                        onlyInteger: true,
                                        offset: digitsInventory * 7
                                    }
                                }
                                this.chartType = 'Line'
                                break
                            case 'suppliers':
                                this.chartOptions = {
                                    fullWidth: true,
                                    height: '14em',
                                    horizontalBars: false
                                }
                                this.chartType = 'Bar'
                                break
                            case 'sales':
                                // get the digit length of the max quantity in series and adjust axisY offset accordingly
                                var digitsSales = obj.chart_data.max_series.toString().length // 555555591
                                this.chartOptions = {
                                    fullWidth: true,
                                    height: '14em',
                                    axisX: {
                                        labelOffset: {
                                            x: -12,
                                            y: 6
                                        }
                                    },
                                    axisY: {
                                        onlyInteger: true,
                                        offset: digitsSales * 7
                                    }
                                }
                                this.chartType = 'Line'
                                break
                            case 'warehouse':
                                // get the digit length of the max quantity in series and adjust axisY offset accordingly
                                var digitsWarehouse = obj.chart_data.max_series.toString().length // 555555591
                                this.chartOptions = {
                                    fullWidth: true,
                                    height: '14em',
                                    horizontalBars: false,
                                    seriesBarDistance: 31,
                                    axisY: {
                                        onlyInteger: true,
                                        offset: digitsWarehouse * 7
                                    }
                                }
                                this.chartType = 'Bar'
                                break
                            case 'distributors':
                                // get the digit length of the max quantity in series and adjust axisY offset accordingly
                                var digitsDistributors = obj.chart_data.max_series.toString().length // 555555591
                                this.chartOptions = {
                                    fullWidth: true,
                                    height: '14em',
                                    axisX: {
                                        labelOffset: {
                                            x: -6,
                                            y: 6
                                        }
                                    },
                                    axisY: {
                                        onlyInteger: true,
                                        offset: digitsDistributors * 10
                                    }
                                }
                                this.chartType = 'Line'
                                this.legendLabels = obj.legend_labels
                                break
                        }
                        this.chartData = obj.chart_data
                        this.messageData = ''
                    } else {
                        this.messageData = 'No data'
                    }
                } else {
                    this.messageData = obj.message
                }
            })
        },
        changeSection(which) {
            if (which != this.currentSection) {
                this.currentSection = which
                this.fetchSectionData()
            }
        },
        setDealerSort(which) {
            if (this.loadingDealerData) { return }
            if (this.filters.sort_column == which) {
                this.filters.sort_descending = !this.filters.sort_descending
            } else {
                this.filters.sort_column = which
            }
            this.filters.page = 1
            this.fetchDealerList(true)
        },
        updateSelectedDealers(dealer) {
            if (this.selectedDealers.indexOf(dealer.client_id) > -1) {
                this.selectedDealers.splice(this.selectedDealers.indexOf(dealer.client_id), 1)
            } else {
                this.selectedDealers.push(dealer.client_id)
            }
        },
        selectAllDealers(which) {
            setTimeout(() => {
                this.selectedDealers = []
                if (which == 'stocking_dealers') {
                    this.selectingAllNonStockingDealers = false
                    if (this.selectingAllStockingDealers) {
                        this.dealers.forEach(dealer => {
                            if (dealer.client_type_code != 'FFL_OFFICE') {
                                this.selectedDealers.push(dealer.client_id)
                            }
                        })
                    }
                } else {
                    this.selectingAllStockingDealers = false
                    if (this.selectingAllNonStockingDealers) {
                        this.nonStockingDealers.forEach(dealer => {
                            if (dealer.client_type_code != 'FFL_OFFICE') {
                                this.selectedDealers.push(dealer.client_id)
                            }
                        })
                    }
                }
            }, 10);
        },
        emailSelectedDealers() {
            if (this.selectedDealers.length < 1) {
                return
            }
            if (!this.dealerEmail.subject) {
                this.dealerEmail.subject = this.item_title
            }
            if (!this.dealerEmail.product_title) {
                this.dealerEmail.product_title = this.item_title
            }
            this.showModalEmailDealers = true
        },
        selectedDealerData() {
            let emailDealers = []
            for (let i = 0; i < this.dealers.length; i++) {
                if (this.selectedDealers.indexOf(this.dealers[i].client_id) >= 0) {
                    emailDealers.push(this.dealers[i])
                }
            }
            for (let i = 0; i < this.nonStockingDealers.length; i++) {
                if (this.selectedDealers.indexOf(this.nonStockingDealers[i].client_id) >= 0) {
                    emailDealers.push(this.nonStockingDealers[i])
                }
            }
            return emailDealers
        },
        updateEmailContent(content) {
			this.dealerEmail.content = content
		},
        validateDealerEmail() {
            for (const [key, value] of Object.entries(this.dealerEmail)) {
                if (!value) {
                    return false
                }
            }
            return true
        },
        previewEmail() {
            if (this.validateDealerEmail()) {
                this.showEmailPreview = true
                this.emailInvalid = false
                this.emailPreviewContent = ''
                this.emailErrorContent = ''
                this.dealerEmailMessage = ''
                let postData = {
                    email: this.dealerEmail,
                    recipients: [],
                    product_id: this.product_id,
                    preview_only: true
                }
                this.selectedDealerData().forEach(item => postData.recipients.push({ client_id: item.client_id, email_address: item.email_address, company_name: item.company_name }))
                this.apiCall({ destination: 'send_dealer_product_email', data: postData }).then(obj => {
                    if (obj.status == 'success') {
                        this.emailPreviewContent = obj.email_content
                    } else {
                        this.emailInvalid = true
                        this.emailErrorContent = obj.message
                    }
                })
            }
        },
        sendEmail() {
            if (this.sendingDealerEmail || this.emailInvalid || this.dealerEmailMessage) { return }
            this.dealerEmailMessage = ''
            this.sendingDealerEmail = true
            let postData = {
                email: this.dealerEmail,
                recipients: [],
                product_id: this.product_id
            }
            this.selectedDealerData().forEach(item => postData.recipients.push({ client_id: item.client_id, email_address: item.email_address, company_name: item.company_name }))
            this.apiCall({ destination: 'send_dealer_product_email', data: postData }).then(obj => {
                this.dealerEmailMessage = obj.message
                if (obj.status == 'success') {
                    // TODO:?
                    this.sendingDealerEmail = false // only while debugging! allows hitting the send button again
                } else {
                    this.sendingDealerEmail = false
                }
            })
        },
        getDealer(dealer) {
            this.dealerDetail = dealer
            this.messageDealerData = 'Loading'
            this.loadingDealerData = true
            this.showDealerDetail = true
            this.apiCall({ destination: 'get_dealer_data', data: { product_id: this.product_id, location_id: dealer.location_id } }).then(obj => {
                this.loadingDealerData = false
                if (obj.status == 'success') {
                    this.dealerData.inventoryHistory = obj.inventory_history
                    this.dealerData.supplierHistory = obj.supplier_history
                    this.dealerData.currentInventory = obj.current_inventory
                    this.messageDealerData = ''
                } else {
                    this.messageDealerData = obj.message
                }
            })
            this.getDealerHistory(dealer.location_id)
        },
        getDealerHistory(locationId) {
            this.messageDealerHistory = 'Loading'
            this.apiCall({ destination: 'get_dealer_history', data: { product_id: this.product_id, location_id: locationId } }).then(obj => {
                this.loadingDealerHistory = false
                if (obj.status == 'success') {
                    this.dealerHistory = obj.dealer_history
                    this.messageDealerHistory = ''
                } else {
                    this.messageDealerHistory = obj.message
                }
            })
        },
        editProductLocation(history) {
            this.editingLocation = JSON.parse(JSON.stringify(history));
            this.editingLocationScope = 'all'
            this.showModal = true
        },
        clearEditingLocation() {
            this.editingLocation.quantity = 0
            this.editingLocation.received = 0
            this.editingLocation.sold = 0
            this.editingLocation.online_sold = 0
            this.editingLocation.disposed = 0
            this.editingLocation.cost = 0
            this.editingLocation.price = 0
            this.editingLocation.online_price = 0
        },
        saveProductLocation() {
            if (this.savingProductLocation) {
                return false
            }
            if (this.editingLocationScope == 'delete') {
                this.clearEditingLocation()
            }
            this.savingProductLocation = true
            this.editingLocation.scope = this.editingLocationScope
            this.editProductLocationMessage = 'Saving (this could take several minutes)...'
            this.apiCall({ destination: 'save_product_location', data: this.editingLocation }).then(obj => {
                this.editProductLocationMessage = obj.message
                this.savingProductLocation = false
                if (obj.status == 'success') {
                    // close the modal and reload item data
                    this.showModal = false
                    this.fetchData()
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.report-heading { margin: 0 0 2em 0; }
.controls {
    text-align: right;
    .button { font-size: 0.75em; width: 2em; text-align: center; padding: 0.5em 0.5em; }
}
.item-detail {
    margin: 1em;
}
.two-columns {
    align-items: start;
}
.item-details {
    display: grid;
    grid-template-columns: 1fr 1fr 2fr;
    grid-gap: 2em;
    align-items: start;
    margin: 0 0 3em 0;
}
h2.heading {
    border-bottom: 1px solid #ccc; padding-bottom: 0.1em;
    position: relative;
    button {
        font-size: 0.33em;
        position: absolute;
        top: 0;
        right: 0;
    }
}
.data-heading {
    display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    h2 { color: #ccc; }
    h2.live { color: #333; }
    h2:hover { cursor: pointer; color: #333; }
    .fas { font-size: 0.8em; padding: 0 0 0 0.5em; }
}
h3 {
    padding: 0.66em 0 0 0;
}
.caption { font-size: 0.66em; color: #999; }

.list-count {
    //float: right;
    margin: 1em 0;
    font-size: 0.8em;
    text-align: right;
    input { display: inline-block; width: 16em; margin: 0 0 0 1em; }
}

.item-image {
    text-align: center;
    img { max-width: 100%; }
}
.empty-list { margin: 2em 0; }
.chart-loading { height: 5.55em; }
.specifications {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 0.5em;
    align-items: center;
    label { text-align: right; font-size: 0.75em; }
}
.specifications-wide {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    grid-gap: 0.75em;
    align-items: center;
    label { text-align: right; font-size: 0.75em; }
    .meta { text-align: left; line-height: 1em; }
}
.specifications-manufacturers {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0.75em;
    align-items: flex-start;
    .distributor-rows, .supplier-rows {
        display: grid;
        grid-template-columns: 2fr 1fr;
        grid-gap: 0.75em;
        align-items: center;
        label { text-align: right; font-size: 0.75em; }
        .meta { text-align: left; line-height: 1em; }
    }
}
.sales {
    .row {
        display: grid;
        grid-template-columns: 4em 4em 1fr 1fr 1fr 5em;
        line-height: 2em;
        label { font-size: 0.75em; text-align: right; }
        &.heading { line-height: 1.5em; }
    }
}
.dealer-list, .dealer-list-totals {
    margin: 0 1em 2em 1em;
    &.loading { cursor: wait; }
    .report-row {
        line-height: 1em;
        grid-template-columns: 4fr 1fr 1fr 0.66fr 1fr 1fr 0.66fr 0.66fr 0.66fr 1fr 1fr 3em;
        .meta { text-align: left; }
        .dealer-name {
            display: grid; grid-template-columns: 2em 2em 1fr;
        }
        button {
            font-size: 0.75em; padding: 0.33em 0.1em 0.33em 0.4em; display: inline-block;
        }
        &.heading { line-height: 1.5em; }
        &.inventory-history {
            grid-template-columns: 1fr 1fr 1fr 1fr;
            label { padding: 0 1em 0 0; }
        }
        &.supplier-history { grid-template-columns: 2fr 1fr 1fr; }
        &.dealer-history { grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 3em; }
    }
}
.dealer-list-totals {
    height: auto;
}
.load-more-link {
    display: inline-block;
    margin: 0 1em 0 0;
    font-weight: bold;
    cursor: pointer;
    &.disabled {
        cursor: not-allowed;
        color: #ccc;
    }
}
.dealer-list-non-stocking {
    .report-row {
        grid-template-columns: 1fr;
    }
}
.dealer-name-modal { display: grid; grid-template-columns: 2em 1fr; }
.full-cds { color: #ccc; padding: 0 0.5em 0 0; }
.logbooks-only { color: #ccc; padding: 0 0.5em 0 0; }
.dealer-detail-heading {
    display: grid; align-items: center; grid-template-columns: 1fr 3em;
    label { width: auto; padding: 0 1em 0 0; }
}
.daily-history-filters {
    border-bottom: 1px solid #ccc;
    margin: 0 0 1em 0;
    display: grid;
    grid-template-columns: 1fr 20em;
    align-items: center;
    label { font-size: 0.66em; }
    input[type="date"] { font-size: 0.8em; }
    .input-go { font-size: 0.9em; }
}
.email-dealers-modal {
    .inner { width: 60em; max-width: 60em; height: 70vh; max-height: 70vh; }
    .content { height: calc(70vh - 5em); max-height: calc(70vh - 5em); }
    .item-title { text-align: center; padding: 0; }
    .email-label { display: block; background-color: #dfdce3; margin: 1em 0 0.5em 0; padding: 0.25em 0.5em; color: #333; }
    textarea { height: 8em; }
}
.email-preview {
    position: fixed;
    z-index: 1001;
    background: rgba(255, 255, 255, 0.6);
    box-sizing: border-box;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: grid;
    align-items: center;
    justify-items: center;
    .email-preview-inner {
	    background: white;
	    box-shadow: 0 2px 6px hsla(0, 0%, 0%, 0.2);
	    padding: 0;
		height: 90vh;
		width: 65em;
	}
    .email-preview-loading {
        font-size: 2em;
        margin: 3em;
        text-align: center;
    }
    .email-preview-controls {
        border-top: 1px solid #ccc;
        background-color: #e4e4e4;
        padding: 0.5em;
    }
    .email-preview-content {
        height: calc(100% - 3.5em);
        overflow-y: scroll;
        padding: 1em;
    }
    .email-preview-heading {
        margin: 0 0 1em 0;
        padding: 0.66em 0.5em;
        font-size: 1.5em;
        background: #333;
        color: #fff;
        text-align: center;
    }
    .email-preview-meta {
        display: grid;
        grid-template-columns: 5em 1fr;
        grid-gap: 1em;
        margin: 0 0 1em 0;
        padding: 0 0 1em 0;
        border-bottom: 1px solid #ccc;
    }
    .email-preview-message {
        font-size: 1.1em;
    }
    .email-preview-product-details {
        padding: 1em 2em 1em 2em;
        margin: 1em 0 0 0;
        border-top: 1px solid #ccc;
        h1 { text-align: center; font-size: 2em; margin: 0 0 1em 0; }
    }
    .email-preview-product-meta {
        display: grid;
        grid-template-columns: 2fr 2fr 1fr;
        margin: 2em 3em;
    }
    .email-preview-order-button {
        background-color: #666;
    }
    .email-preview-footnote {
        font-size: 0.9em;
        color: #666;
        margin: 1em 0 0 0;
        padding: 1em 0;
        border-top: 1px solid #ccc;
    }
}
</style>
